import React from 'react';

const SearchResultItemPlaceholder = () => {
  return (
    <div className="tooldialog__wrapper">
      <ul className="generic-list">
        {Array.from({ length: 10 }, (_, i) => (
          <li key={`result-item__placeholder${i}`} className="result-item__placeholder">
            <div className="text__placeholder shimmer" />
            <div className="text__placeholder--small shimmer" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchResultItemPlaceholder;
